import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Progress } from '../components/ui/progress';
import { FolderKanban, Plus, Clock, CheckCircle2, Circle } from 'lucide-react';

const Projects = () => {
  const projects = [
    { name: 'Business Formation', status: 'completed', progress: 100, tasks: 5, completedTasks: 5 },
    { name: 'Marketing Setup', status: 'in-progress', progress: 60, tasks: 8, completedTasks: 5 },
    { name: 'Financial Planning', status: 'in-progress', progress: 30, tasks: 6, completedTasks: 2 },
    { name: 'Legal Documentation', status: 'pending', progress: 0, tasks: 4, completedTasks: 0 },
  ];

  const getStatusBadge = (status) => {
    switch (status) {
      case 'completed': return <Badge className="bg-teal-100 text-teal-700">Completed</Badge>;
      case 'in-progress': return <Badge className="bg-purple-100 text-purple-700">In Progress</Badge>;
      default: return <Badge className="bg-slate-100 text-slate-700">Pending</Badge>;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-800 mb-2">Projects</h1>
            <p className="text-slate-600">Track and manage your business development projects</p>
          </div>
          <Button className="bg-gradient-to-r from-purple-500 to-teal-500 hover:from-purple-600 hover:to-teal-600">
            <Plus className="w-4 h-4 mr-2" /> New Project
          </Button>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {projects.map((project, idx) => (
            <Card key={idx} className="border-0 shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-teal-100 rounded-lg flex items-center justify-center">
                      <FolderKanban className="w-5 h-5 text-purple-600" />
                    </div>
                    <div>
                      <CardTitle className="text-lg">{project.name}</CardTitle>
                      <p className="text-sm text-slate-500">{project.completedTasks} of {project.tasks} tasks</p>
                    </div>
                  </div>
                  {getStatusBadge(project.status)}
                </div>
              </CardHeader>
              <CardContent>
                <div className="mb-2 flex items-center justify-between text-sm">
                  <span className="text-slate-500">Progress</span>
                  <span className="font-medium">{project.progress}%</span>
                </div>
                <Progress value={project.progress} className="h-2" />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
